import * as v from "valibot";

import { rpcContract } from "../rpc";

export const updateUnifiedLinksOrderRpcContract = rpcContract({
  name: "updateUnifiedLinksOrder",
  paramsSchema: v.object({
    linkIds: v.array(v.string()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
  }),
});

export type UpdateUnifiedLinksOrderParams = v.InferOutput<(typeof updateUnifiedLinksOrderRpcContract)["paramsSchema"]>;
export type UpdateUnifiedLinksOrderResult = v.InferOutput<(typeof updateUnifiedLinksOrderRpcContract)["resultSchema"]>;
